// src/components/atomic-crm/providers/supabase/data-provider/enrichAvatar.ts
import { supabase } from "../supabase";
import { processCompanyLogo, processContactAvatar } from "./avatarProcessors";

/**
 * Fire-and-forget avatar enrichment.
 * Never throws. Never blocks the caller.
 * If avatar fetching fails (CORS, 404, timeout, etc.), the record
 * keeps its default avatar and we move on.
 */
export const enrichAvatar = async (
  resource: "contacts" | "companies",
  record: any,
): Promise<void> => {
  try {
    const processor =
      resource === "contacts" ? processContactAvatar : processCompanyLogo;

    // processX expects a { data: {...} } params object (same shape as beforeCreate)
    const updated = await processor({ data: record });

    // If the processor mutated the record with an avatar, persist it
    const newAvatar = (updated as any)?.data?.avatar;
    const currentAvatar = record?.avatar;
    if (newAvatar && newAvatar !== currentAvatar) {
      await supabase
        .from(resource)
        .update({ avatar: newAvatar })
        .eq("id", record.id);
    }
  } catch (e: any) {
    // One concise log line. Not an error, just informational.
    console.warn(
      `[avatar] skipped for ${resource}#${record?.id}:`,
      e?.message || e,
    );
  }
};
